import React from "react";
import { Card } from "antd";

function createContent(html) {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

const ContentCard = (props) => (
  <Card
    style={{
      width: "75%",
      marginLeft: "60px",
      // marginTop: "10px",
      marginBottom: "30px",
      borderRadius: 20,
      boxShadow: "3px 3px 3px #809de1",
    }}
    bodyStyle={{ fontSize: "24px", fontFamily: "Arial " }}
  >
    {createContent(props.content)}

  </Card>
);
export default ContentCard;
